<!--人员管理-->
<template>
  <div class="trialScGlIndexClass">
    <div>
      <nav-com activeIndex="4"></nav-com>
    </div>

    <div style="padding: 15px">
      <div style="text-align: left">
        <div class="searchMainClass">
          <el-row :gutter="24">
            <el-col :span="24">
              <el-form>
                <el-form-item label="小区名称： ">
                  <el-input
                    placeholder="请输入小区名称..."
                    v-model="search.COMPANY_NAME"
                  ></el-input>
                  <label style="margin-left:6px;">经纪人信息：</label>
                  <el-input
                    placeholder="请输入经纪人信息..."
                    v-model="search.JJRINFO"
                  ></el-input>
                  <label style="margin-left:6px;">客户信息：</label>
                  <el-input
                    placeholder="请输入客户信息..."
                    v-model="search.KHINFO"
                  ></el-input>
                  <label style="margin-left:6px;">成交状态：</label>
                  <el-select placeholder="请选择" v-model="search.DEAL_STATUS">
                    <el-option label="全部" value=""></el-option>
                    <el-option label="居间合同" value="1"></el-option>
                    <el-option label="网签批贷" value="2"></el-option>
                    <el-option label="过户" value="3"></el-option>
                    <el-option label="退单" value="4"></el-option>
                    <el-option label="交易完成" value="5"></el-option>
                  </el-select>
                  <label style="margin-left:6px;">佣金状态：</label>
                  <el-select
                    placeholder="请选择"
                    v-model="search.COMMISSION_STATUS"
                  >
                    <el-option label="全部" value=""></el-option>
                    <el-option label="未结佣" value="0"></el-option>
                    <el-option label="已结佣" value="1"></el-option>
                  </el-select>
                  <el-button
                    type="success"
                    style="margin-left: 15px;margin-right: 15px"
                    @click="mainLoad"
                  >
                    综合查询
                  </el-button>
                  <div style="float:right;margin-right:10px;">
                    <upload-curr-com
                      :mainLoadData="mainLoad"
                      :op="op"
                      :paramData="search"
                      :tableColumns="tableColumns"
                      mbBtnTxt="导出售房报表"
                      isUpLoadBtn="0"
                      isDownBtn="1"
                    ></upload-curr-com>
                  </div>
                </el-form-item>
              </el-form>
            </el-col>
          </el-row>
        </div>
      </div>

      <!-- table列表  开始 -->

      <div style="position: relative;">
        <el-table
          height="80vh"
          :data="tableData"
          border
          style="width: 100%"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column label="操作" width="280">
            <template slot-scope="scope">
              <el-button
                @click="openFinalPaymentReceivedDialog(scope.row)"
                type="text"
                size="small"
                style="color: #67C23A"
              >
                确认尾款已收到
              </el-button>
              <el-button
                @click="openCommissionPaidDialog(scope.row)"
                type="text"
                size="small"
                style="color: #409EFF"
              >
                确认经纪人佣金已发放
              </el-button>
            </template>
          </el-table-column>
          <template v-for="(col, index) in tableColumns">
            <el-table-column
              :prop="col.colName"
              :label="col.colText"
              :key="index"
              v-if="col.colShow"
            >
              <template slot-scope="scope">
                <div
                  v-if="
                    col.colName === 'COMMISSION_STATUS' ||
                      col.colName === 'DEAL_STATUS' ||
                      col.colName === 'DEPOSIT_VOUCHER_IMAGES' ||
                      col.colName === 'ISFINALPAY' ||
                      col.colName === 'DEAL_DATETIME' ||
                      col.colName === 'FINAL_PAYMENT_DATE' ||
                      col.colName === 'COMMISSION_DATE' ||
                      col.colName === 'CREATE_TIME' ||
                      col.colName === 'UPDATE_TIME' ||
                      col.colName === 'ONLINE_SIGNING_DATE' ||
                      col.colName === 'TRANSFER_DATE' ||
                      col.colName === 'HANDOVER_DATE'
                  "
                >
                  <div v-if="col.colName === 'COMMISSION_STATUS'">
                    <span
                      v-if="scope.row.COMMISSION_STATUS === '0'"
                      style="color:red;font-weight:bold"
                      >未结佣</span
                    >
                    <span
                      v-if="scope.row.COMMISSION_STATUS === '1'"
                      style="color:green;font-weight:bold"
                      >已结佣</span
                    >
                  </div>
                  <div v-else-if="col.colName === 'DEAL_STATUS'">
                    <span v-if="scope.row.DEAL_STATUS === '1'">居间合同</span>
                    <span v-if="scope.row.DEAL_STATUS === '2'">网签批贷</span>
                    <span v-if="scope.row.DEAL_STATUS === '3'">过户</span>
                    <span v-if="scope.row.DEAL_STATUS === '4'">退单</span>
                    <span v-if="scope.row.DEAL_STATUS === '5'">交接完成</span>
                  </div>
                  <div v-else-if="col.colName === 'DEPOSIT_VOUCHER_IMAGES'">
                    <a
                      v-if="getImageCount(scope.row.DEPOSIT_VOUCHER_IMAGES) > 0"
                      href="javascript:void(0);"
                      @click="
                        openImageDialog(
                          scope.row.DEPOSIT_VOUCHER_IMAGES,
                          '定金凭证'
                        )
                      "
                      style="color: #409EFF; text-decoration: none; cursor: pointer;"
                    >
                      查看图片({{
                        getImageCount(scope.row.DEPOSIT_VOUCHER_IMAGES)
                      }})
                    </a>
                    <span v-else style="color: #909399;">无</span>
                  </div>
                  <div v-else-if="col.colName === 'ISFINALPAY'">
                    <span
                      v-if="scope.row.ISFINALPAY === '1'"
                      style="color:green;font-weight:bold"
                      >已收款</span
                    >
                    <span
                      v-if="scope.row.ISFINALPAY === '0'"
                      style="color:orange;font-weight:bold"
                      >未收款</span
                    >
                  </div>
                  <div v-else-if="col.colName === 'DEAL_DATETIME'">
                    {{
                      formatDateTime(scope.row.DEAL_DATE, scope.row.DEAL_TIME)
                    }}
                  </div>
                  <div v-else-if="col.colName === 'FINAL_PAYMENT_DATE'">
                    {{ formatStandardDateTime(scope.row.FINAL_PAYMENT_DATE) }}
                  </div>
                  <div v-else-if="col.colName === 'COMMISSION_DATE'">
                    {{ formatStandardDateTime(scope.row.COMMISSION_DATE) }}
                  </div>
                  <div v-else-if="col.colName === 'CREATE_TIME'">
                    {{ formatStandardDateTime(scope.row.CREATE_TIME) }}
                  </div>
                  <div v-else-if="col.colName === 'UPDATE_TIME'">
                    {{ formatStandardDateTime(scope.row.UPDATE_TIME) }}
                  </div>
                  <div v-else-if="col.colName === 'ONLINE_SIGNING_DATE'">
                    {{ formatStandardDateTime(scope.row.ONLINE_SIGNING_DATE) }}
                  </div>
                  <div v-else-if="col.colName === 'TRANSFER_DATE'">
                    {{ formatStandardDateTime(scope.row.TRANSFER_DATE) }}
                  </div>
                  <div v-else-if="col.colName === 'HANDOVER_DATE'">
                    {{ formatStandardDateTime(scope.row.HANDOVER_DATE) }}
                  </div>
                </div>
                <div v-else>
                  {{ scope.row[col.colName] }}
                </div>
              </template>
            </el-table-column>
          </template>
        </el-table>
        <div style="float: right;margin-top: 20px;">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageSet.currentPage"
            :page-sizes="pageSet.pageSizeS"
            :page-size="pageSet.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pageSet.totalNums"
          >
          </el-pagination>
        </div>
      </div>

      <!-- table列表  结束 -->

      <!-- 确认尾款已收到对话框 开始 -->
      <el-dialog
        title="确认尾款已收到"
        :visible.sync="finalPaymentReceivedDialog.visible"
        width="600px"
      >
        <el-form :model="finalPaymentReceivedDialog.row" label-width="140px">
          <el-form-item label="成交单号">
            <el-input
              v-model="finalPaymentReceivedDialog.row.CUSTOMER_DEAL_ID"
              :disabled="true"
            ></el-input>
          </el-form-item>
          <el-form-item label="小区名称">
            <el-input
              v-model="finalPaymentReceivedDialog.row.COMMUNITYNAME"
              :disabled="true"
            ></el-input>
          </el-form-item>
          <el-form-item label="房源信息">
            <el-input
              :value="
                finalPaymentReceivedDialog.row.BUILDING_NO +
                  '栋' +
                  finalPaymentReceivedDialog.row.UNIT_NO +
                  '单元' +
                  finalPaymentReceivedDialog.row.HOUSE_NO +
                  '号'
              "
              :disabled="true"
            ></el-input>
          </el-form-item>
          <el-form-item label="客户姓名">
            <el-input
              v-model="finalPaymentReceivedDialog.row.CUSTOMER_NAME"
              :disabled="true"
            ></el-input>
          </el-form-item>
          <el-form-item label="成交价格（元）">
            <el-input
              v-model="finalPaymentReceivedDialog.row.DEAL_PRICE"
              type="number"
              placeholder="请输入成交价格"
            >
              <template slot="append">元</template>
            </el-input>
          </el-form-item>
          <el-form-item label="定金金额（元）">
            <el-input
              v-model="finalPaymentReceivedDialog.row.DEPOSIT_AMOUNT"
              type="number"
              :disabled="true"
            >
              <template slot="append">元</template>
            </el-input>
          </el-form-item>
          <el-form-item label="尾款（元）">
            <el-input
              :value="
                calculateBalanceForDialog(
                  finalPaymentReceivedDialog.row.DEAL_PRICE,
                  finalPaymentReceivedDialog.row.DEPOSIT_AMOUNT
                )
              "
              :disabled="true"
            >
              <template slot="append">元</template>
            </el-input>
          </el-form-item>
          <el-form-item label="已付定金凭证图片">
            <el-input
              v-model="finalPaymentReceivedDialog.row.DEPOSIT_VOUCHER_IMAGES"
              type="textarea"
              :rows="2"
              placeholder="请输入图片URL，多个用逗号分隔"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="凭证图片预览"
            v-if="
              getImageCount(
                finalPaymentReceivedDialog.row.DEPOSIT_VOUCHER_IMAGES
              ) > 0
            "
          >
            <div style="display: flex; flex-wrap: wrap; gap: 10px;">
              <div
                v-for="(img, index) in parseImages(
                  finalPaymentReceivedDialog.row.DEPOSIT_VOUCHER_IMAGES
                )"
                :key="index"
                style="width: 100px; height: 100px;"
              >
                <el-image
                  :src="img"
                  :preview-src-list="
                    parseImages(
                      finalPaymentReceivedDialog.row.DEPOSIT_VOUCHER_IMAGES
                    )
                  "
                  fit="cover"
                  style="width: 100%; height: 100%; cursor: pointer; border-radius: 4px; border: 1px solid #dcdfe6;"
                >
                  <div
                    slot="error"
                    style="display: flex; justify-content: center; align-items: center; height: 100%; background: #f5f7fa; color: #909399;"
                  >
                    <i
                      class="el-icon-picture-outline"
                      style="font-size: 24px;"
                    ></i>
                  </div>
                </el-image>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="是否尾款收款">
            <el-select
              v-model="finalPaymentReceivedDialog.row.ISFINALPAY"
              style="width:100%"
            >
              <el-option label="已收款" value="1"></el-option>
              <el-option label="未收款" value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="尾款收款时间"
            v-if="finalPaymentReceivedDialog.row.ISFINALPAY === '1'"
          >
            <el-date-picker
              v-model="finalPaymentReceivedDialog.row.FINAL_PAYMENT_DATE"
              type="datetime"
              placeholder="选择尾款收款时间"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              style="width:100%"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="备注">
            <el-input
              v-model="finalPaymentReceivedDialog.row.REMARKS"
              type="textarea"
              :rows="3"
              placeholder="请输入备注信息"
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="finalPaymentReceivedDialog.visible = false"
            >取消</el-button
          >
          <el-button type="primary" @click="saveFinalPaymentReceived"
            >确定收款</el-button
          >
        </div>
      </el-dialog>
      <!-- 确认尾款已收到对话框 结束 -->

      <!-- 确认经纪人佣金已发放对话框 开始 -->
      <el-dialog
        title="确认经纪人佣金已发放"
        :visible.sync="commissionPaidDialog.visible"
        width="600px"
      >
        <el-form :model="commissionPaidDialog.row" label-width="140px">
          <el-form-item label="成交单号">
            <el-input
              v-model="commissionPaidDialog.row.CUSTOMER_DEAL_ID"
              :disabled="true"
            ></el-input>
          </el-form-item>
          <el-form-item label="销售经纪人姓名">
            <el-input
              v-model="commissionPaidDialog.row.SALES_AGENT_NAME"
              :disabled="true"
            ></el-input>
          </el-form-item>
          <el-form-item label="销售经纪人电话">
            <el-input
              v-model="commissionPaidDialog.row.SALES_AGENT_PHONE"
              :disabled="true"
            ></el-input>
          </el-form-item>
          <el-form-item label="佣金金额（元）">
            <el-input
              v-model="commissionPaidDialog.row.COMMISSION_AMOUNT"
              type="number"
              placeholder="请输入佣金金额"
            >
              <template slot="append">元</template>
            </el-input>
          </el-form-item>
          <el-form-item label="佣金比例（%）">
            <el-input
              v-model="commissionPaidDialog.row.COMMISSION_RATE"
              placeholder="请输入佣金比例"
            >
              <template slot="append">%</template>
            </el-input>
          </el-form-item>
          <el-form-item label="佣金状态">
            <el-select
              v-model="commissionPaidDialog.row.COMMISSION_STATUS"
              style="width:100%"
            >
              <el-option label="未结佣" value="0"></el-option>
              <el-option label="已结佣" value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="佣金结算日期"
            v-if="commissionPaidDialog.row.COMMISSION_STATUS === '1'"
          >
            <el-date-picker
              v-model="commissionPaidDialog.row.COMMISSION_DATE"
              type="date"
              placeholder="选择佣金结算日期"
              format="yyyy-MM-dd"
              value-format="yyyyMMdd"
              style="width:100%"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="佣金凭证图片">
            <el-input
              v-model="commissionPaidDialog.row.COMMISSION_VOUCHER_IMAGES"
              type="textarea"
              :rows="2"
              placeholder="请输入图片URL，多个用逗号分隔"
            ></el-input>
          </el-form-item>
          <el-form-item label="备注">
            <el-input
              v-model="commissionPaidDialog.row.REMARKS"
              type="textarea"
              :rows="3"
              placeholder="请输入备注信息"
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="commissionPaidDialog.visible = false"
            >取消</el-button
          >
          <el-button type="primary" @click="saveCommissionPaid"
            >确定发放</el-button
          >
        </div>
      </el-dialog>
      <!-- 确认经纪人佣金已发放对话框 结束 -->

      <!-- 图片查看对话框 开始 -->
      <el-dialog
        :title="imageDialog.title"
        :visible.sync="imageDialog.visible"
        width="80%"
        top="5vh"
      >
        <div style="max-height: 70vh; overflow-y: auto;">
          <el-row :gutter="20">
            <el-col
              :span="8"
              v-for="(img, index) in imageDialog.images"
              :key="index"
              style="margin-bottom: 20px;"
            >
              <el-card :body-style="{ padding: '10px' }">
                <el-image
                  :src="img"
                  :preview-src-list="imageDialog.images"
                  fit="cover"
                  style="width: 100%; height: 200px; cursor: pointer;"
                >
                  <div
                    slot="error"
                    style="display: flex; justify-content: center; align-items: center; height: 100%; background: #f5f7fa; color: #909399;"
                  >
                    <i
                      class="el-icon-picture-outline"
                      style="font-size: 40px;"
                    ></i>
                  </div>
                </el-image>
                <div
                  style="text-align: center; margin-top: 10px; font-size: 12px; color: #606266;"
                >
                  图片 {{ index + 1 }}
                </div>
              </el-card>
            </el-col>
          </el-row>
          <div
            v-if="imageDialog.images.length === 0"
            style="text-align: center; padding: 50px; color: #909399;"
          >
            <i class="el-icon-picture-outline" style="font-size: 60px;"></i>
            <div style="margin-top: 10px;">暂无图片</div>
          </div>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="imageDialog.visible = false">关闭</el-button>
        </div>
      </el-dialog>
      <!-- 图片查看对话框 结束 -->
    </div>
  </div>
</template>

<script>
import NavCom from "../../components/navCom/NavMainCom.vue";
import UploadCurrCom from "../../components/uploadCurrCom/UploadCurrCom.vue";
import allParam from "../../allParam/allParam.vue";
var utilPost, op;
export default {
  name: "SaleOrderGlIndex",
  components: { NavCom, UploadCurrCom, allParam },
  data() {
    return {
      rows: [],
      action: allParam.downMbUrl,
      objDataParam: "",
      search: {},
      /**分页 开始 */
      pageSet: {
        currentPage: 1, //当前页页码
        pageSizeS: [10, 50, 100, 1000],
        pageSize: 10, //每页默认显示的条数
        totalNums: 0 //数据总条数
      },
      /**分页 结束 */
      tableColumns: [
        {
          colName: "CUSTOMER_DEAL_ID",
          colText: "成交单号",
          colShow: true
        },
        {
          colName: "HOUSEID",
          colText: "房源ID",
          colShow: false
        },
        {
          colName: "COMMUNITYNAME",
          colText: "小区名称",
          colShow: true
        },
        {
          colName: "BUILDING_NO",
          colText: "楼栋号",
          colShow: true
        },
        {
          colName: "UNIT_NO",
          colText: "单元",
          colShow: true
        },
        {
          colName: "HOUSE_NO",
          colText: "门牌号",
          colShow: true
        },
        {
          colName: "FLOOR",
          colText: "楼层",
          colShow: true
        },
        {
          colName: "DEAL_STATUS",
          colText: "成交状态",
          colShow: true
        },
        {
          colName: "DEAL_PRICE",
          colText: "实际成交价格（万元）",
          colShow: true
        },
        {
          colName: "DEAL_DATETIME",
          colText: "签约时间",
          colShow: true
        },
        {
          colName: "DEPOSIT_AMOUNT",
          colText: "定金",
          colShow: true
        },
        {
          colName: "DEPOSIT_VOUCHER_IMAGES",
          colText: "定金凭证",
          colShow: true
        },
        {
          colName: "ISFINALPAY",
          colText: "是否尾款收款",
          colShow: true
        },
        {
          colName: "FINAL_PAYMENT_DATE",
          colText: "尾款收款时间",
          colShow: true
        },
        {
          colName: "SALES_AGENT_NAME",
          colText: "销售经纪人姓名",
          colShow: true
        },
        {
          colName: "SALES_AGENT_PHONE",
          colText: "销售经纪人电话",
          colShow: true
        },
        {
          colName: "SALES_AGENT_STORE",
          colText: "销售所属门店",
          colShow: true
        },
        {
          colName: "CUSTOMER_NAME",
          colText: "客户姓名",
          colShow: true
        },
        {
          colName: "CUSTOMER_PHONE",
          colText: "客户电话",
          colShow: true
        },
        {
          colName: "CUSTOMER_ID_CARD",
          colText: "客户身份证号码",
          colShow: true
        },
        {
          colName: "COMMISSION_AMOUNT",
          colText: "佣金金额（元）",
          colShow: true
        },
        {
          colName: "COMMISSION_RATE",
          colText: "佣金比例",
          colShow: true
        },
        {
          colName: "COMMISSION_STATUS",
          colText: "佣金状态",
          colShow: true
        },
        {
          colName: "COMMISSION_DATE",
          colText: "佣金结算日期",
          colShow: true
        },
        {
          colName: "REMARKS",
          colText: "备注",
          colShow: true
        },
        {
          colName: "CREATENAME",
          colText: "创建人",
          colShow: true
        },
        {
          colName: "CREATE_TIME",
          colText: "创建时间",
          colShow: true
        },
        {
          colName: "UPDATENAME",
          colText: "更新人",
          colShow: true
        },
        {
          colName: "UPDATE_TIME",
          colText: "更新时间",
          colShow: true
        },
        {
          colName: "ONLINE_SIGNING_DATE",
          colText: "网签时间",
          colShow: true
        },
        {
          colName: "TRANSFER_DATE",
          colText: "过户时间",
          colShow: true
        },
        {
          colName: "HANDOVER_DATE",
          colText: "交接时间",
          colShow: true
        },
        {
          colName: "EXPECTED_PROCESS_DATE",
          colText: "预计办手续时间",
          colShow: true
        },
        {
          colName: "EXPENSE_COST",
          colText: "居间合同支出费用",
          colShow: true
        },
        {
          colName: "INCOME_COST",
          colText: "居间合同收入费用",
          colShow: true
        },
        {
          colName: "ONLINE_SIGNING_EXPENSE",
          colText: "网签批贷支出费用",
          colShow: true
        },
        {
          colName: "ONLINE_SIGNING_INCOME",
          colText: "网签批贷收入费用",
          colShow: true
        },
        {
          colName: "TRANSFER_EXPENSE",
          colText: "过户支出费用",
          colShow: true
        },
        {
          colName: "TRANSFER_INCOME",
          colText: "过户收入费用",
          colShow: true
        },
        {
          colName: "HANDOVER_EXPENSE",
          colText: "交接完成支出费用",
          colShow: true
        },
        {
          colName: "HANDOVER_INCOME",
          colText: "交接完成收入费用",
          colShow: true
        },
        {
          colName: "REFUND_EXPENSE",
          colText: "退单支出费用",
          colShow: true
        },
        {
          colName: "REFUND_INCOME",
          colText: "退单收入费用",
          colShow: true
        }
      ],
      tableData: [],
      row: {},
      dialogVisible: false,
      // 确认尾款已收到对话框
      finalPaymentReceivedDialog: {
        visible: false,
        row: {}
      },
      // 确认经纪人佣金已发放对话框
      commissionPaidDialog: {
        visible: false,
        row: {}
      },
      // 图片查看对话框
      imageDialog: {
        visible: false,
        title: "",
        images: []
      }
    };
  },
  created() {
    this.op = "adminCustomerDealGl";
    this.utilPost = this.$util.handler;
  },
  mounted() {
    this.mainLoad();
  },
  methods: {
    handleSelectionChange(val) {
      this.rows = val;
    },
    /**分页方法 开始 */
    handleSizeChange(val) {
      this.pageSet.pageSize = val;
      this.mainLoad();
    },
    handleCurrentChange(val) {
      this.pageSet.currentPage = val;
      this.mainLoad();
    },
    //加载主列表数据
    mainLoad() {
      //alert(JSON.stringify(this.pageSet));
      var busData = {
        pageSet: this.pageSet,
        search: this.search
      };
      var paramData = {
        headerData: {
          op: this.op, //反射名称
          methodName: "mainLoad" //对应的方法名
        },
        busData: busData //参数内容
      };
      this.utilPost.paramData = paramData;
      this.utilPost.sendPost().then(data => {
        //alert(JSON.stringify(data));
        if (!data.isSuccess) {
          alert(data.msg);
          this.isShowContent = false;
          return;
        }
        this.pageSet.totalNums = data.totalNums;
        this.tableData = data.content;
        this.isShowContent = true;
      });
    },
    roleBgHandler(row) {
      this.row = row;
      this.dialogVisible = true;
    },
    /**分页方法 结束 */

    // 打开确认尾款已收到对话框
    openFinalPaymentReceivedDialog(row) {
      this.finalPaymentReceivedDialog.row = JSON.parse(JSON.stringify(row));
      this.finalPaymentReceivedDialog.visible = true;

      // 如果是否尾款收款为"是"且没有尾款收款时间，自动填充当前时间
      if (
        this.finalPaymentReceivedDialog.row.ISFINALPAY === "1" &&
        !this.finalPaymentReceivedDialog.row.FINAL_PAYMENT_DATE
      ) {
        const now = new Date();
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, "0");
        const day = String(now.getDate()).padStart(2, "0");
        const hours = String(now.getHours()).padStart(2, "0");
        const minutes = String(now.getMinutes()).padStart(2, "0");
        const seconds = String(now.getSeconds()).padStart(2, "0");
        this.finalPaymentReceivedDialog.row.FINAL_PAYMENT_DATE = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
      }
    },

    // 保存确认尾款已收到
    saveFinalPaymentReceived() {
      // 验证必填项
      if (
        !this.finalPaymentReceivedDialog.row.DEAL_PRICE ||
        this.finalPaymentReceivedDialog.row.DEAL_PRICE <= 0
      ) {
        alert("请输入有效的成交价格");
        return;
      }

      if (
        !this.finalPaymentReceivedDialog.row.DEPOSIT_AMOUNT ||
        this.finalPaymentReceivedDialog.row.DEPOSIT_AMOUNT <= 0
      ) {
        alert("请输入有效的定金金额");
        return;
      }

      // 如果选择了已收款，则必须填写尾款收款时间
      if (this.finalPaymentReceivedDialog.row.ISFINALPAY === "1") {
        if (!this.finalPaymentReceivedDialog.row.FINAL_PAYMENT_DATE) {
          alert("已收款状态下，请选择尾款收款时间");
          return;
        }
      }

      if (!confirm("确认提交尾款信息吗？")) {
        return;
      }

      var busData = {
        row: this.finalPaymentReceivedDialog.row
      };
      var paramData = {
        headerData: {
          op: this.op,
          methodName: "confirmFinalPaymentReceived"
        },
        busData: busData
      };

      this.utilPost.paramData = paramData;
      this.utilPost.sendPost().then(data => {
        alert(data.msg);
        if (data.isSuccess) {
          this.finalPaymentReceivedDialog.visible = false;
          this.mainLoad(); // 刷新列表
        }
      });
    },

    // 打开确认经纪人佣金已发放对话框
    openCommissionPaidDialog(row) {
      this.commissionPaidDialog.row = JSON.parse(JSON.stringify(row));
      this.commissionPaidDialog.visible = true;

      // 如果佣金状态为已结佣且没有佣金结算日期，自动填充当前日期
      if (
        this.commissionPaidDialog.row.COMMISSION_STATUS === "1" &&
        !this.commissionPaidDialog.row.COMMISSION_DATE
      ) {
        const now = new Date();
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, "0");
        const day = String(now.getDate()).padStart(2, "0");
        this.commissionPaidDialog.row.COMMISSION_DATE = year + month + day;
      }
    },

    // 保存确认经纪人佣金已发放
    saveCommissionPaid() {
      // 验证必填项
      if (
        !this.commissionPaidDialog.row.COMMISSION_AMOUNT ||
        this.commissionPaidDialog.row.COMMISSION_AMOUNT <= 0
      ) {
        alert("请输入有效的佣金金额");
        return;
      }

      if (
        this.commissionPaidDialog.row.COMMISSION_STATUS === "1" &&
        !this.commissionPaidDialog.row.COMMISSION_DATE
      ) {
        alert("请选择佣金结算日期");
        return;
      }

      if (!confirm("确认经纪人佣金已发放吗？")) {
        return;
      }

      var busData = {
        row: this.commissionPaidDialog.row
      };
      var paramData = {
        headerData: {
          op: this.op,
          methodName: "confirmCommissionPaid"
        },
        busData: busData
      };

      this.utilPost.paramData = paramData;
      this.utilPost.sendPost().then(data => {
        alert(data.msg);
        if (data.isSuccess) {
          this.commissionPaidDialog.visible = false;
          this.mainLoad(); // 刷新列表
        }
      });
    },

    // 获取图片数量
    getImageCount(imageStr) {
      if (!imageStr || imageStr === "[]" || imageStr === "") {
        return 0;
      }
      try {
        const images = JSON.parse(imageStr);
        return Array.isArray(images) ? images.length : 0;
      } catch (e) {
        return 0;
      }
    },

    // 解析图片列表
    parseImages(imageStr) {
      if (!imageStr || imageStr === "[]" || imageStr === "") {
        return [];
      }
      try {
        const images = JSON.parse(imageStr);
        return Array.isArray(images) ? images : [];
      } catch (e) {
        return [];
      }
    },

    // 打开图片查看对话框
    openImageDialog(imageStr, title) {
      this.imageDialog.title = title;
      this.imageDialog.images = this.parseImages(imageStr);
      this.imageDialog.visible = true;
    },

    // 格式化标准日期时间：智能判断是否显示时间部分
    // 如果服务端返回的是日期，则只显示 yyyy-MM-dd
    // 如果服务端返回的是日期时间，则显示 yyyy-MM-dd HH:mm:ss
    formatStandardDateTime(dateTimeStr) {
      if (!dateTimeStr || dateTimeStr === "") {
        return "";
      }

      const str = dateTimeStr.toString().trim();

      // 处理已格式化的日期时间字符串（包含 - 和 :）
      if (str.includes("-") && str.includes(":")) {
        // yyyy-MM-dd HH:mm:ss 格式，截取前19位
        if (str.length >= 19) {
          return str.substring(0, 19);
        }
        return str;
      }

      // 处理已格式化但只包含 - 的字符串（可能是 yyyy-MM-dd 或带空格的日期）
      if (str.includes("-") && !str.includes(":")) {
        // 如果包含空格，可能是 yyyy-MM-dd HH:mm:ss 但冒号丢失了，直接返回
        if (str.includes(" ")) {
          return str;
        }
        // 纯日期格式 yyyy-MM-dd
        if (str.length === 10 && /^\d{4}-\d{2}-\d{2}$/.test(str)) {
          return str;
        }
        return str;
      }

      // 处理纯数字格式（最常见的数据库格式）
      if (/^\d+$/.test(str)) {
        // yyyyMMddHHmmss 格式（14位或更多）- 包含时间
        if (str.length >= 14) {
          const year = str.substring(0, 4);
          const month = str.substring(4, 6);
          const day = str.substring(6, 8);
          const hour = str.substring(8, 10);
          const minute = str.substring(10, 12);
          const second = str.substring(12, 14);
          return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
        }

        // yyyyMMdd 格式（8位）- 仅日期
        if (str.length === 8) {
          const year = str.substring(0, 4);
          const month = str.substring(4, 6);
          const day = str.substring(6, 8);
          return `${year}-${month}-${day}`;
        }
      }

      // 处理时间戳格式（13位毫秒或10位秒）
      if (/^\d{10,13}$/.test(str)) {
        const timestamp =
          str.length === 13 ? parseInt(str) : parseInt(str) * 1000;
        const date = new Date(timestamp);
        if (!isNaN(date.getTime())) {
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, "0");
          const day = String(date.getDate()).padStart(2, "0");
          const hour = String(date.getHours()).padStart(2, "0");
          const minute = String(date.getMinutes()).padStart(2, "0");
          const second = String(date.getSeconds()).padStart(2, "0");
          return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
        }
      }

      // 其他情况直接返回原值
      return str;
    },

    // 格式化日期时间：将 yyyyMMdd 和 HHmmss 转换为 yyyy-MM-dd HH:mm:ss
    formatDateTime(date, time) {
      if (!date || date === "") {
        return "";
      }

      // 处理日期：yyyyMMdd -> yyyy-MM-dd
      const dateStr = date.toString();
      if (dateStr.length !== 8) {
        return date + (time ? " " + time : "");
      }

      const year = dateStr.substring(0, 4);
      const month = dateStr.substring(4, 6);
      const day = dateStr.substring(6, 8);

      let formattedDateTime = `${year}-${month}-${day}`;

      // 处理时间：HHmmss -> HH:mm:ss
      if (time && time !== "") {
        const timeStr = time.toString().padStart(6, "0"); // 确保是6位数字
        const hours = timeStr.substring(0, 2);
        const minutes = timeStr.substring(2, 4);
        const seconds = timeStr.substring(4, 6);
        formattedDateTime += ` ${hours}:${minutes}:${seconds}`;
      } else {
        formattedDateTime += " 00:00:00";
      }

      return formattedDateTime;
    },

    // 计算尾款（用于对话框显示）
    calculateBalanceForDialog(dealPrice, depositAmount) {
      if (!dealPrice || dealPrice === "" || dealPrice === "0") {
        return "0.00";
      }

      const price = parseFloat(dealPrice) || 0;
      const deposit = parseFloat(depositAmount) || 0;
      const balance = price - deposit;

      return balance.toFixed(2);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.trialScGlIndexClass {
  .addClassModel {
    padding-left: 15px;
    padding-right: 15px;
  }
  .trainSetClassMain .el-input {
    width: 60% !important;
  }
  .el-dialog {
    margin-top: 15px !important;
    width: 90%;
  }
  .searchMainClass .el-input {
    width: 150px !important;
  }
  .longLabelClass .el-input {
    width: 372px !important;
  }
  .el-table td.el-table__cell div {
    font-weight: 600 !important;
  }
  .cell {
    text-align: center !important;
  }
  .mainDivJd {
    .el-progress-bar__innerText {
      color: #f300ff !important;
    }
  }

  .fzrsMainDiv {
    text-align: left;
    margin-bottom: 10px;
  }
  .dwInfoDivId {
    .el-form-item__content {
      float: left;
    }
  }
  /deep/ .el-dialog {
    margin-top: 15px !important;
  }
  /deep/ .el-input--small .el-input__inner {
    height: 29px;
    line-height: 29px;
  }
  /deep/ .el-form-item__label {
    line-height: 32px !important;
  }
  /deep/ .el-form-item--small.el-form-item {
    margin-bottom: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/saleOrderGlIndex/SaleOrderGlIndex.vue